import { flow, groupBy, toPairs, map, filter, sortBy } from 'lodash/fp';
import filterValidDesignText from './utils/filterValidDesignText';
import messages from './messages/materialMessages';
import makeDisplayName from './utils/makeDisplayName';
import makeItemLookup from './utils/makeItemLookup';
import groupByMeasure from './utils/groupByMeasure';
import getItemMeasurement from './utils/getItemMeasurement';
import hasItemMeasure from './utils/hasItemMeasure';
import convertOperations from './utils/convertOperations';
import findImage from './utils/findImage';
import makeId from './utils/makeId';
import makeDisplayProductName from './utils/makeDisplayProductName';

export function generateWallPanels(businessRules, items) {
  const { wallPanelMaterials } = businessRules;
  if (!wallPanelMaterials){
    return [];
  }
  const itemLookup = makeItemLookup(items);
  return wallPanelMaterials.map((material) => ({
    id: material.id,
    displayName: messages[material.id] || { id: `cwt.materials.${material.id}` },
    expressions: createExpressions(material, items),
    operations: convertOperations(material.operations || {}, itemLookup),
  })).filter((material) => {
    if (material.expressions.length === 0) {
      // eslint-disable-next-line no-console
      console.error('Excluding wall panel material:', material.id, 'due to no expressions');
      return false;
    }
    return true;
  });
}


export function createExpressions(material, items) {
  return flow(
    filter((item) => material.products.includes(item.ProductNameGlobal)),
    filterValidDesignText('wall panel expression', material.id),
    groupBy(makeId),
    toPairs,
    map(([id, itemsWithSameDesign]) => ({
      id,
      displayName: makeDisplayName(itemsWithSameDesign[0]),
      displayProductName: makeDisplayProductName(itemsWithSameDesign[0], material.includeProductNameInExpression),
      displayImage: findImage(itemsWithSameDesign[0], 'S3', { ImageType: 'Picture Single' }, 1),
      displayImageLarge: findImage(itemsWithSameDesign[0], 'S4', { ImageType: 'Picture Single' }, 1),
      functionalImage: findImage(itemsWithSameDesign[0], 'S3', { ImageType: 'Functional Product Picture' }, 2),
      functionalImageLarge: findImage(itemsWithSameDesign[0], 'S4', { ImageType: 'Functional Product Picture' }, 2),
      priceByArea: hasItemMeasure(itemsWithSameDesign[0], 'Area'),
      minPrice: itemsWithSameDesign.reduce((prev, i2) => Math.min(prev, i2.price), itemsWithSameDesign[0].price),
      thickness: getItemMeasurement(itemsWithSameDesign[0], 'Thickness'),
      heights: groupByMeasure(itemsWithSameDesign, 'Max. height')
        .map((itemsWithSameHeight) => ({
          minLength: groupByMeasure(itemsWithSameHeight.items, 'Min. length')[0].measure,
          minHeight: groupByMeasure(itemsWithSameHeight.items, 'Min. height')[0].measure,
          maxHeight: itemsWithSameHeight.measure,
          item: itemsWithSameHeight.items[0],
        })),
    })),
    sortBy(['minPrice', 'displayName']),
  )(items);
}
